// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.conditionalJsonButtonContainer button[data-v-91da4a58] {\r\n        margin: 0 20px 10px 0;\r\n        padding: 5px;\r\n        background-color: #FFD831;\r\n        border: 1px solid #000000;\r\n        border-radius: 5px;\r\n        cursor: pointer;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
